import { getErrorPayload } from '@application/helpers/api-helper';
import EmailTemplatesApi from '@infrastructure/email-templates-api';
import { createAsyncThunk } from '@reduxjs/toolkit';
export const upsertEmailTemplateAsync = createAsyncThunk('emailTemplates/upsert', async (request, { rejectWithValue }) => {
    try {
        const response = await EmailTemplatesApi.upsertEmailTemplate(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEmailTemplatesByEventIdAsync = createAsyncThunk('emailTemplates/getByEventId', async (eventId, { rejectWithValue }) => {
    try {
        const response = await EmailTemplatesApi.getEmailTemplatesByEventId(eventId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEmailTemplateByIdAsync = createAsyncThunk('emailTemplates/getById', async (id, { rejectWithValue }) => {
    try {
        const response = await EmailTemplatesApi.getEmailTemplateById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEmailTemplateByContextAsync = createAsyncThunk('emailTemplates/getByContext', async (request, { rejectWithValue }) => {
    try {
        const response = await EmailTemplatesApi.getEmailTemplateByContext(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEventEmailTemplatesAsync = createAsyncThunk('emailTemplates/getEventEmailTemplates', async (request, { rejectWithValue }) => {
    try {
        const response = await EmailTemplatesApi.getEventEmailTemplates(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const toggleEmailTemplatesByEventAndTypeAsync = createAsyncThunk('emailTemplates/toggleByEventAndType', async (request, { rejectWithValue }) => {
    try {
        const response = await EmailTemplatesApi.toggleEmailTemplatesByEventAndType(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createDefaultEmailTemplatesAsync = createAsyncThunk('emailTemplates/createDefaultTemplates', async (request, { rejectWithValue }) => {
    try {
        const response = await EmailTemplatesApi.createDefaultEmailTemplates(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
